/*
 * @Github: https://github.com/wangjiawei2019
 * @Date: 2019-06-20 18:10:14
 * @LastEditors: wjw
 * @LastEditTime: 2019-12-13 13:58:06
 */
import http from "./index";

export default {
  /**
   * @description: 获取首页导航栏
   * @param {type}
   * @return: Promise
   */
  getFristCategory() {
    return http.post("/index/getFristCategory", { type: "pc" });
  },
  /*获取首页的主标题*/
  getTitle() {
    return http.get("/index/title");
  },
  /*获取展示的4个展示图片*/
  getExhibitions() {
    return http.get("/index/exhibition");
  },
  /*获取3个轮播区域的集合*/
  getCarousels() {
    return http.post("/index/carousel");
  },
  /*获取文章列表*/
  getArticles() {
    return http.get("/index/article");
  },
  /*获取会员列表*/
  getMembers() {
    return http.get("/index/members");
  },
  /*获取首页底部内容*/
  getFootArticleList() {
    return http.post("/index/getFootArticleList");
  },
  /* 获取首页底部大学导航链接 */
  getSchoolStationList() {
    return http.get("/index/schoolStationList");
  }
};



// WEBPACK FOOTER //
// ./src/api/homeApi.js